@if (tila() === kuutionTilat.VAPAA) {
  <svg [attr.width]="koko()" [attr.height]="koko()" viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <g stroke="#b4bac2" stroke-dasharray="2.2 2.6">
      <path d="M12 3l9 4.5v9L12 21l-9-4.5v-9z"></path>
      <path d="M3 7.5l9 4.5 9-4.5M12 12v9"></path>
    </g>
  </svg>
} @else {
  <svg [attr.width]="koko()" [attr.height]="koko()" [class.sininen]="tila() === kuutionTilat.VAPAA_TALLENNETAAN" [class.oranssi]="tila() === kuutionTilat.REKISTERI_PAIVITETAAN" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M12 3l9 4.5v9L12 21l-9-4.5v-9z"></path>
    <path d="M3 7.5l9 4.5 9-4.5M12 12v9"></path>
    @if (tila() === kuutionTilat.VAPAA_TALLENNETAAN) {
      <circle cx="18.5" cy="18.5" r="6" fill="#fff" stroke="none"></circle>
      <path d="M18.5 15.3v6.4M15.3 18.5h6.4" stroke-width="2.2"></path>
    }
    @if (tila() === kuutionTilat.REKISTERI_PAIVITETAAN) {
      <circle cx="18.5" cy="18.5" r="6" fill="#fff" stroke="none"></circle>
      <path d="M21.2 17.1a3 3 0 1 0 .3 2.6" stroke-width="2"></path>
      <path d="M21.7 15.2v2.3h-2.3" stroke-width="2"></path>
    }
  </svg>
}
